<template>
  <v-container>
    <material-card>
      <v-layout px-3 slot="header">
        <v-flex my-4 pl-4 title align-center justify-center>{{ title }}</v-flex>

        <v-spacer></v-spacer>

        <v-flex>
          <v-text-field
            prepend-icon="mdi-magnify"
            name="search"
            label="Wyszukaj"
            color="white"
            clearable
            v-model="search"
          ></v-text-field>
        </v-flex>
      </v-layout>

      <v-layout text-xs-right>
        <v-flex>
          <check-permission permissions="ACCOUNT.REGISTER">
            <v-btn large color="error" @click="$emit('add')">DODAJ URZĘDNIKA</v-btn>
          </check-permission>
        </v-flex>
      </v-layout>

      <material-table
        linkField="userId"
        editField="userId"
        roleLinkField="officialRoles"
        entityType="profile"
        editPerm="PROFILE.UPDATE"
        deletePerm="PROFILE.DELETE"
        :roleAddAction="true"
        :items="users"
        :headers="headers"
        :total-count="count"
        :search="search"
        :actions="true"
        @delete="$emit('delete', $event)"
        @edit="$emit('edit', $event)"
        @pagination="$emit('pagination', $event)"
      ></material-table>
    </material-card>
  </v-container>
</template>

<script>
import MaterialCard from '@/components/material/Card';
import MaterialTable from '@/components/material/Table';

/**
 * @vuese
 * @group Officials
 * Lista urzędników
 */

export default {
  components: {
    MaterialTable,
    MaterialCard
  },
  props: {
    // Tytuł strony
    title: String,
    // Lista urzędników
    users: Array,
    // Całkowita liczba urzędników
    count: Number
    // Link do szczegółów
  },
  data: () => ({
    headers: [
      { value: 'email', text: 'Adres e-mail', link: true },
      { value: 'firstName', text: 'Imię' },
      { value: 'lastName', text: 'Nazwisko' }
    ],
    search: ''
  })
};
</script>

<style>
</style>
